import { formatHtml } from "@trumpf/ux.common-storybook";
import { DownloadSliderTemplate } from "./download-slider.templates";

export default {
    title:
        "Website/Page Templates/Search/Search Results Sliders/Download Slider",
    render: DownloadSliderTemplate.bind({}),
    tags: ["autodocs"],
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const DownloadSlider = {};
